import type { App } from 'vue'
import type { Router } from 'vue-router'
import VueMatomo from 'vue-matomo'

export function initMatomo(app: App, router: Router) {
    const matomoHost = import.meta.env.VITE_MATOMO_HOST || window.appConfig?.matomoHost
    const matomoSiteId = import.meta.env.VITE_MATOMO_SITE_ID || window.appConfig?.matomoSiteId

    if (!matomoHost || !matomoSiteId) return

    const plugin = 'default' in VueMatomo ? VueMatomo.default : VueMatomo
    app.use(plugin, {
        host: matomoHost,
        siteId: Number(matomoSiteId),
        router,
        disableCookies: true,
        enableLinkTracking: true,
    })
}
